export const Rings = ({ size = 28, stroke = "#987E54", opacity = 1, className = "", ...props }) => {
  const r = size * 0.32;
  const cy = size / 2;
  const left = size / 2 - r * 0.52;
  const right = size / 2 + r * 0.52;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ opacity }}
      {...props}
    >
      <circle cx={left} cy={cy} r={r} stroke={stroke} strokeWidth={size / 22} />
      <circle cx={right} cy={cy} r={r} stroke={stroke} strokeWidth={size / 22} />
    </svg>
  );
};

export const RingsField = ({ className = "" }) => (
  <svg
    viewBox="0 0 600 600"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <circle cx="240" cy="300" r="190" stroke="#B69766" strokeOpacity="0.16" strokeWidth="1" />
    <circle cx="360" cy="300" r="190" stroke="#1A1C23" strokeOpacity="0.08" strokeWidth="1" />
    <circle cx="300" cy="220" r="260" stroke="#B69766" strokeOpacity="0.08" strokeWidth="1" />
  </svg>
);
